(function(){
        if (!document.getElementById('24736bf97cb783c02410cf281e384f701eec2d0675c1d9f6e89acc8662e22a6a')) {
            var e = document.createElement('style');
            e.id = '24736bf97cb783c02410cf281e384f701eec2d0675c1d9f6e89acc8662e22a6a';
            e.textContent = `.swiper-fade.swiper-free-mode .swiper-slide {
  transition-timing-function: ease-out;
}
.swiper-fade .swiper-slide {
  pointer-events: none;
  transition-property: opacity;
}
.swiper-fade .swiper-slide .swiper-slide {
  pointer-events: none;
}
.swiper-fade .swiper-slide-active {
  pointer-events: auto;
}
.swiper-fade .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}
`;
            document.head.appendChild(e);
        }
    })();